// Container Placement Popup
let containerDatasourceId;
let currentStep = 0;
let maxLength = 201;
let userAnswers = [];
let BackstepID = [];
let backProgress = false;
let previousStepValue;
let currentAnswer;
let finalArray = [];
let postStepID;
let postAnswerVal;
let postCurrentStepId;
let postCurrentAnswerVal;
let postZipVal;
let finishStepCheck = false;
let isLocalEnv = false;

if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
  isLocalEnv = true;
}

const initContainerPlacement = () => {
  const innerInit = () => {
    containerDatasourceId = $('.component-timeline').attr('data-datasourceId');
    if ($('#component-placement').length > 0) {
      feather.replace();
    }
  };

  // Managing Disabled / Enabled CTA Buttons
  $(document).on('click', 'input[type=radio]', function () {
    if ($(this).prop('checked') == true) {
      $('[id^="nextstep"]').removeAttr('disabled');
      currentAnswer = $(this).val();
    } else {
      $('[id^="nextstep"]').attr('disabled', true);
    }
  });

  // On Image click adding CSS and managing CTA Buttons Enabled / Disabled
  $(document).on('click', '.image-checkbox', function (e) {
    e.preventDefault();
    const $checkbox = $(this).find('input[type="checkbox"], input[type="radio"]');

    $('.image-checkbox').removeClass('image-checkbox-checked'); // Clear Check mark class
    $(this).addClass('image-checkbox-checked');
    $checkbox.prop('checked', true).css('border', '1px solid #f00');

    if ($(this).find('input[type=radio]').prop('checked') == true) {
      $('[id^="nextstep"]').removeAttr('disabled');
      currentAnswer = $(this).find('input[type=radio]').val();
    } else {
      $('[id^="nextstep"]').attr('disabled', true);
    }
  });

  // Textarea functionalities and managing CTA Buttons Enabled / Disabled
  $(document).on('keyup', '#placementDetails', function () {

    const textlen = $(this).val().length;
    $('#chars').text(textlen);

    if (textlen > 0) {
      $('[id^="nextstep"]').removeAttr('disabled');
      currentAnswer = $(this).val();
    } else {
      $('[id^="nextstep"]').attr('disabled', true);
    }

    if (textlen >= 201) {
      $(this).addClass('error');
      $('.charcount').addClass('error');
      $('[id^="nextstep"]').attr('disabled', true);
    } else {
      $(this).removeClass('error');
      $('.charcount').removeClass('error');
    }
  });

  // AJAX Fucntion on Popup, Next and Previous
  function ajaxRequest(URL) {
    const request = {
      ContainerDatasourceId: containerDatasourceId,
      UsersAnswersObject: finalArray,
      StepID: postCurrentStepId,
      AnswerVal: postCurrentAnswerVal,
      ZipVal: postZipVal,
    };

    // setTimeout(function () {
    //   $('#placementDetails').keyup();
    // }, 200);

    $.ajax({
      type: 'POST',
      url: URL,
      contentType: 'application/json',
      dataType: 'json',
      cache: false,
      data:JSON.stringify(request),
      success: function(data) {
        window.currentstate = data;
        $('[data-id=placementModal] .modal-dialog').remove();

        if (backProgress != true) {
          currentStep++;
        }

        generateContainerPlacement(data);
        $('.modal-backdrop:gt(0)').remove();
        $('input[type=radio]').prop('checked',false);

        if (currentStep > 1) {
          $('[id^="previousstep"],[data-id^="previousstep"]').removeAttr('disabled');
        } else {
          $('[id^="previousstep"],[data-id^="previousstep"]').attr('disabled' , true);
        }

        if (data[0].IsContainerReviewPanel || data[0].IsMultiselectPanel) {
          $('[id^="nextstep"],[data-id^="nextstep"]').removeAttr('disabled');
        } else {
          $('[id^="nextstep"],[data-id^="nextstep"]').attr('disabled' , true);
        }

        if (backProgress) {
          $('.component-timeline_journey.current').find('.component-radio li').each (function () {
            if ($(this).find('input[type=radio]').val() == previousStepValue) {
              $(this).find('input[type=radio]').prop('checked', true).trigger('click');
              $('[id^="nextstep"],[data-id^="nextstep"]').removeAttr('disabled');
            }
          });

          $('.component-timeline_journey.current').find('.placement-grid .placement-image').each (function () {
            if ($(this).find('input[type=radio]').val() == previousStepValue) {
              $(this).find('input[type=radio]').prop('checked', true).trigger('click');
              $(this).find('.image-checkbox').addClass('image-checkbox-checked');
              $('[id^="nextstep"],[data-id^="nextstep"]').removeAttr('disabled');
            }
          });
        }
        $('#placementDetails').keyup(); // Trigger keyup to advance "Notes" textarea without being required
      },
      error: function(data, textStatus, errorThrown) {
        console.log('Error getting data', textStatus, errorThrown);
      }
    });
  }

  if ($('.component-timeline_journey').length) {
    $(document).on('click', '#placementModal, [data-id=placementModal] .close', function (e) {
      if (e.target == this) {
        invalidateContainerPlacement();
        $('#placementModal').modal('hide');
        $('[data-id=placementModal]').modal('hide');
        $('main').removeClass('container-backdrop');

        if ($('.component-timeline_journey').hasClass('current')) {
          $('.component-timeline_journey').removeClass('current');
        }
      }
    });
  }

  $(document).on('click', '[id^="finishstep"],[data-id^="finishstep"]', function () {
    // $('#placementModal').modal('hide');
    $('[data-id=placementModal]').modal('hide');
    $('.container-intro').addClass('d-none');
    $('.component-container-placement').find('.confirmed').removeClass('d-none');
    $('main').removeClass('container-backdrop');
    $(this).parents('.component-timeline_journey').removeClass('current');

    finishStepCheck = true;
    enableSubmitIfValid();
  });

  function enableSubmitIfValid() {
    var moveLegCard = $('.component-timeline_journey-card.InProgress');
    var address = moveLegCard.find('.AddressRequired');
    var zipCode = moveLegCard.find('.ZipCode');
    var datepicker = moveLegCard.find('.datepicker');

    if (finishStepCheck && address.val() && zipCode.val() && datepicker.val()) {
      moveLegCard.find('.component-container-placement .container-intro').removeClass('container-error');
      moveLegCard.find('.component-container-placement .container-intro span').addClass('d-none');
      moveLegCard.find('.submitInlineForm').removeClass('disabled');
    }

    validDateBtnEnabler();
  }

  $(document).on('click', '[data-id="containerplacementModal"]', function (e) {
    e.preventDefault();

    $(this).parents('.component-timeline_journey').addClass('current');
    // $(this).closest('.component-timeline_journey.current').find('#placementModal').modal('show');
    $(this).closest('.component-timeline_journey.current').find('[data-id=placementModal]').modal('show');

    if ($('body').hasClass('modal-open')) {
      $('main').addClass('container-backdrop');
    }

    isLocalEnv ? (URL = '/api/sitecore/container-placement-1/getnextstep') : (URL = '/api/sitecore/containerplacement/getnextstep');

    ajaxRequest(URL);
  });

  $(document).on('click', '[id^="nextstep"],[data-id^="nextstep"]', function (e) {
    e.preventDefault();
    backProgress = false;

    let previousStepId = $(this).closest('.modal-dialog').attr('data-stepid');
    let ZipRegulation = $('.ZipCode').val();
    let getId = currentstate[0].CurrentStepId;

    BackstepID.push(getId);
    postStepID = getId;

    if ($('#placementDetails').length) {
      previousStepValue = true;
    } else if ($('.component-checkbox').length) {
      previousStepValue = true;
    } else if ($('.nostepselection').length) {
      currentAnswer = true;
      previousStepValue = true;
    } else {
      previousStepValue = $('.Stepvalue:checked').val();
    }

    userAnswers[currentStep-1] = currentAnswer;
    postAnswerVal = currentAnswer;
    postCurrentStepId = previousStepId;
    postCurrentAnswerVal = previousStepValue;
    postZipVal = ZipRegulation;

    isLocalEnv ? (URL =`/api/sitecore/container-placement-1/previousStepId=${previousStepId}/previousStepValue=${previousStepValue}`) : (URL = `/api/sitecore/containerplacement/getnextstep?previousStepId=${previousStepId}&previousStepValue=${previousStepValue}&zipcode=${ZipRegulation}`);

    finalArray[currentStep-1] = {stepID:postStepID,value:postAnswerVal};
    ajaxRequest(URL);
  });

  $(document).on('click', '[id^="previousstep"],[data-id^="previousstep"]', function (e) {
    e.preventDefault();
    backProgress = true;

    let ZipRegulation = $('.ZipCode').val();

    previousStepValue = userAnswers;
    previousStepValue = previousStepValue[previousStepValue.length-1];
    currentStep--;
    postCurrentStepId = BackstepID[BackstepID.length-1];
    postCurrentAnswerVal = previousStepValue;
    postZipVal = ZipRegulation;

    isLocalEnv ? (URL = `/api/sitecore/container-placement-1/getstep/previousStepId=${BackstepID[BackstepID.length-1]}/previousStepValue=${previousStepValue}`) : (URL = `/api/sitecore/containerplacement/getstep?stepid=${BackstepID[BackstepID.length-1]}&previousStepValue=${previousStepValue}&zipcode=${ZipRegulation}`);

    BackstepID.pop();
    userAnswers.pop();
    finalArray.pop();
    ajaxRequest(URL);
  });

  $(innerInit);
}

function invalidateContainerPlacement() {
  currentStep = 0;
  maxLength = 201;
  userAnswers = [];
  BackstepID = [];
  backProgress = false;
  previousStepValue = '';
  currentAnswer = '';
  finalArray = [];
  postStepID = '';
  postAnswerVal = '';
  postCurrentStepId = '';
  postCurrentAnswerVal = '';
  postZipVal = '';
  finishStepCheck = false;

  $('.component-timeline_journey-card.active').find('.submitInlineForm').addClass('disabled');
}

function resetContainerPlacementButton() {
  $('.container-intro').removeClass('d-none');
  $('.component-container-placement').find('.confirmed').addClass('d-none');
}

if (typeof delayTimelineInit === 'undefined' || !delayTimelineInit) {
  initContainerPlacement();
}